import { getPartnerAccessToken } from '@leagueplatform/sso-util';
import { getLocalTimeZone, today, CalendarDate } from '@internationalized/date';

export function isTobaccoUser(indicator: any) {
  return indicator === 'T';
}

export function notTobaccoUser(indicator: any) {
  return indicator === 'N';
}

export function convertTobaccoIndicatorToText(indicator: any) {
  if (indicator) {
    return indicator === 'T' ? 'Yes' : 'No';
  }

  return '--';
}

export function isEmpty(value: any) {
  return value === null || value === undefined || value?.length === 0;
}

export function isLeapYear(year: number) {
  return new Date(year, 1, 29).getDate() === 29;
}

export function isValidDate(lastReportDateAsString: string) {
  const splitDate = lastReportDateAsString.split('/'); // splitDate = [MM, DD, YYYY]
  const month = Number(splitDate[0]);
  const day = Number(splitDate[1]);
  const year = Number(splitDate[2]);

  if (month > 12 || month < 1) {
    return true;
  }
  if (month === 9 || month === 6 || month === 11 || month === 4) {
    if (day > 30 || day <= 0) {
      return true;
    }
  } else if (month === 2) {
    if (isLeapYear(year)) {
      if (day > 29 || day <= 0) {
        return true;
      }
    } else if (!isLeapYear(year)) {
      if (day > 28 || day <= 0) {
        return true;
      }
    }
  }
  if (day > 31 || day <= 0) {
    return true;
  }

  return false;
}

export function isOutsideOfDateRange(lastReportDateAsString: string) {
  const splitDate = lastReportDateAsString.split('/');
  const lastReportDate = new CalendarDate(
    Number(splitDate[2]),
    Number(splitDate[0]),
    Number(splitDate[1]),
  );
  const currentDate = today(getLocalTimeZone());
  const minDate = currentDate.add({ days: 1 }).subtract({ months: 6 }); // 6 months before current Date

  return (
    isValidDate(lastReportDateAsString) ||
    lastReportDate < minDate ||
    lastReportDate > currentDate
  );
}

export function isAboveEighteenAge(userDate: string) {
  const splitLoginUserBirthDate = userDate.split('-');
  const compLoginUserBirthDate = new CalendarDate(
    Number(splitLoginUserBirthDate[0]),
    Number(splitLoginUserBirthDate[1]),
    Number(splitLoginUserBirthDate[2]),
  );
  const currentDate = today(getLocalTimeZone());
  return compLoginUserBirthDate.add({ years: 18 }) <= currentDate;
}

// export const offExchange = true;
// export const onExchange = false;

export async function getAccessToken(url: string, ubk?: string) {
  const token = await getPartnerAccessToken('highmark');
  const requestOptions = {
    method: 'GET',
    headers: new Headers({
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      ...(ubk && { brandUbk: ubk }),
    }),
  };
  try {
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => data);
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}

export async function postAccessToken(url: string, payload: any, ubk?: string) {
  const token = await getPartnerAccessToken('highmark');
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(ubk && { brandUbk: ubk }),
    },
    body: JSON.stringify(payload),
  };
  try {
    // eslint-disable-next-line no-await-in-loop
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => data);
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}
